export default "__VITE_ASSET__NBYWprv9__"